import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as GroupActions from '../../actions/group';
import * as UserActions from '../../actions/users';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { RootState } from '../../reducers';
import { GroupData } from '../../models/Group';
import { UserData } from '../../models/User';
import { StudentData, StudentCredentials } from '../../models/Student';
import { CampaignData } from '../../models/Campaign';
import { Header } from '../Common/header';
import { ReturnButton } from '../Common/returnbutton';
import { StudentContainer } from './studentcontainer';
import { StudentInfo } from './studentinfo';
import { GroupCampaigns } from './groupcampaigns';
import evaluations from '../../constants/evaluations';
import Group from '../../../../../node/src/models/group.model';
import student from 'src/reducers/student';

export namespace GroupSettings {
	export interface Props extends RouteComponentProps<void> {
		groupActions: typeof GroupActions;
		userActions: typeof UserActions;
		group: GroupData;
		groups: Array<GroupData>
		user: UserData;
	}

	export interface State {
		selectedStudent: {
			id: string,
			isNew: boolean
		};
		selectedCampaign: string;
		modalOpen: boolean;
	}
}

@connect(mapStateToProps, mapDispatchToProps)
export default class GroupSettings extends React.Component<GroupSettings.Props, GroupSettings.State> {

	static contextTypes = {
		router: PropTypes.func.isRequired
	}

	constructor(props: GroupSettings.Props) {
		super(props);
		this.state = { selectedStudent: { id: null, isNew: false }, selectedCampaign: null, modalOpen: false };
	}

	addStudent(values: any) {
		const { group, groupActions } = this.props;

		const studentData: StudentData = {
			group: group._id,
			_id: "" + (Date.now() + Math.floor(Math.random() * 1000)),
			firstname: values.firstname as string,
			lastname: values.lastname as string,
			email: ''
		};
		groupActions.addStudent(studentData);
	}

	componentWillReceiveProps(nextProps: GroupSettings.Props) {
		if (this.props.group) {
			if (nextProps.group.students > this.props.group.students) {
				this.setState(() => {
					return {
						selectedStudent: {
							id: nextProps.group.students[nextProps.group.students.length - 1]._id,
							isNew: true
						}
					}
				});
			}
		}
	}

	selectStudent(id: string) {
		this.setState({ selectedStudent: { id, isNew: false } });
	}

	updateStudent(student: StudentData) {
		const { groupActions } = this.props;
		groupActions.updateStudentNames(student);
	}

	deleteStudent(student: StudentData) {
		const { groupActions } = this.props;
		groupActions.deleteStudent(student);
		this.setState({
			selectedStudent: {
				id: null,
				isNew: false
			}
		});
	}

	selectCampaign(id: string) {
		this.setState({ selectedCampaign: id });
	}

	addCampaign(values: any) {
		const { groupActions, group } = this.props;

		const campaignEvaluations = this.getEvaluations(values);

		const campaignData: CampaignData = {
			group: group._id,
			_id: "" + (Date.now() + Math.floor(Math.random() * 1000)),
			evaluations: campaignEvaluations,
			name: values.name,
			active: false
		};

		groupActions.addCampaign(campaignData);
	}

	editCampaign(values: any) {
		const { groupActions, group } = this.props;
		const { selectedCampaign } = this.state;
		const campaign: CampaignData = group.campaigns.find((campaign) => campaign._id === this.state.selectedCampaign);

		const campaignEvaluations = this.getEvaluations(values);

		const campaignData: CampaignData = {
			group: group._id,
			_id: selectedCampaign,
			evaluations: campaignEvaluations,
			name: campaign.name,
			active: false
		};

		groupActions.updateCampaign(campaignData);
	}

	getEvaluations(values: any) {
		let campaignEvaluations = evaluations.slice();
		for (let evaluation of evaluations) {
			campaignEvaluations.find((o) => { return o.tag === evaluation.tag }).amount = values[evaluation.tag] ? values[evaluation.tag] : 0;
		}
		return campaignEvaluations;
	}

	activateCampaign(id: string) {
		const { groupActions, group } = this.props;
		const campaign: CampaignData = group.campaigns.find((campaign) => campaign._id === id);
		campaign.active = !campaign.active;
		groupActions.updateCampaign(campaign);
	}

	updateCampaign(campaign: CampaignData) {
		const { groupActions } = this.props;
		groupActions.updateCampaign(campaign);
	}

	deleteCampaign() {
		const { groupActions } = this.props;
		const campaign = this.props.group.campaigns.find((campaign) => campaign._id === this.state.selectedCampaign);
		groupActions.deleteCampaign(campaign);
		this.setState({ selectedCampaign: null });
	}

	updateStudentCredentials(studentCredentials: StudentCredentials) {
		this.props.groupActions.updateStudentCredentials({
			groups: this.props.groups,
			student: studentCredentials
		});

		this.setState({
			selectedStudent: {
				...this.state.selectedStudent,
				isNew: false
			}
		});
	}

	render() {
		const { user, group, userActions } = this.props;
		const { selectedCampaign } = this.state;

		//if not loaded
		if (!group || !user) {
			return (<div></div>);
		}

		let studentsActions: StudentContainer.Actions = { addStudent: this.addStudent.bind(this), selectStudent: this.selectStudent.bind(this) };
		let studentActions: StudentInfo.Actions = {
			updateStudentNames: this.updateStudent.bind(this),
			updateStudentCredentials: this.updateStudentCredentials.bind(this),
			deleteStudent: this.deleteStudent.bind(this),
			sendEmail: () => { }, createUsernames: () => { },
			sendEmails: () => { }
		};
		let campaignsActions: GroupCampaigns.Actions = { addCampaign: this.addCampaign.bind(this), selectCampaign: this.selectCampaign.bind(this), editCampaign: this.editCampaign.bind(this), deleteCampaign: this.deleteCampaign.bind(this), activateCampaign: this.activateCampaign.bind(this) };


		let selectedStudent = group.students.findIndex((o) => { return o._id === this.state.selectedStudent.id });
		let studentInfo;

		if (selectedStudent !== -1) {
			studentInfo = <StudentInfo
				student={group.students[selectedStudent]}
				newStudent={this.state.selectedStudent.isNew}
				actions={studentActions}
			/>;
		}
		console.log(group.students[selectedStudent] || null);
		return (
			<div>
				<div className="container am_widecontainer">
					<Header user={user} userActions={userActions} />
					<div className="am_teachercontainer">
						<img className="am_icon" src="/images/RedCube.png"></img>
						<img className="am_icon" src="/images/SettingGear.png"></img>
						<h4 className="am_inline"><b>Ryhmän asetukset</b></h4>
						<div className="row">
							<div className="col-3">
								<StudentContainer students={group.students} actions={studentsActions} student={group.students[selectedStudent] || null} />
							</div>
							<div className="col-5">
								{studentInfo}
							</div>
							<div className="col-4">
								<GroupCampaigns campaigns={group.campaigns} actions={campaignsActions} selectedCampaign={selectedCampaign} />
							</div>
						</div>
					</div>
				</div>
				<ReturnButton router={this.context.router} />
			</div>
		);
	}
}

function mapStateToProps(state: RootState, data: any) {
	var id = data.match.params.id;
	console.log(state);
	return {
		groups: state.groups,
		group: state.groups.find((o) => { return o._id === id }),
		user: state.user
	};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
		groupActions: bindActionCreators(GroupActions as {}, dispatch),
		userActions: bindActionCreators(UserActions as {}, dispatch)
	};
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/GroupSettings/index.tsx